import React from 'react';
import ProgressiveImage from 'react-progressive-image';
import Placeholder from './Placeholder';
import Image from './Image';

var ProgressiveImg = function ProgressiveImg(_ref) {
  var image = _ref.image,
      placeholder = _ref.placeholder,
      imageFluid = _ref.imageFluid,
      alt = _ref.alt,
      delay = _ref.delay,
      className = _ref.className,
      height = _ref.height,
      width = _ref.width;
  return /*#__PURE__*/React.createElement(ProgressiveImage, {
    src: image,
    placeholder: placeholder,
    delay: delay
  }, function (src, loading) {
    if (!placeholder) {
      return loading ? /*#__PURE__*/React.createElement(Placeholder, {
        imageFluid: imageFluid,
        height: height,
        width: width
      }) : /*#__PURE__*/React.createElement(Image, {
        src: src,
        alt: alt,
        imageFluid: imageFluid,
        className: className
      });
    }

    return /*#__PURE__*/React.createElement(Image, {
      src: src,
      alt: alt,
      isLoading: loading,
      imageFluid: imageFluid,
      className: className
    });
  });
};

ProgressiveImg.defaultProps = {
  image: null,
  placeholder: null,
  alt: null,
  imageFluid: true,
  delay: null,
  className: null,
  height: undefined,
  width: undefined
};
export default ProgressiveImg;